const log = {
  trace: (...args: any[]) => process.env.NODE_ENV === 'development' && console.trace(...args),
  debug: (...args: any[]) => process.env.NODE_ENV === 'development' && console.debug(...args),
  info: (...args: any[]) => console.info(...args),
  warn: (...args: any[]) => console.warn(...args),
  error: (...args: any[]) => console.error(...args),
};

export default log;